import { useState, useEffect } from "react";

import client from "../client";

export const useGet = ({
  request,
  params,
  skip = false,
}) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [headers, setHeaders] = useState(null);

  useEffect(() => {
    if (!skip) {
      refetch();
    }
  }, [])

  const refetch = () => {
    setLoading(true);
    setError(null);
    setData(null);
    setHeaders(null);

    client
      .get(request.url, {
        params,
        headers: request.headers,
      })
      .then(({ data, headers }) => {
        setData(data);
        setHeaders(headers);
        setLoading(false);
        setError(null);
      })
      .catch((error) => {
        console.error(error)
        setError(error);
        setLoading(false);
      });
  }

  return {
    loading,
    data,
    error,
    headers,
    refetch,
  };
}
